var map = {
	"./_ASEAN.png": "f356",
	"./_African Union(OAS).png": "1ba3",
	"./_Arab League.png": "5ffb",
	"./_CARICOM.png": "0666",
	"./_CIS.png": "37c1",
	"./_Commonwealth.png": "a7d2",
	"./_European Union.png": "37fa",
	"./_Islamic Conference.png": "bc18",
	"./_Kosovo.png": "9b2d",
	"./_NATO.png": "9c88",
	"./_Northern Cyprus.png": "0c8b",
	"./_Northern Ireland.png": "6ca1",
	"./_OPEC.png": "5902",
	"./_Olimpic Movement.png": "c077",
	"./_Red Cross.png": "cc32",
	"./_Somaliland.png": "e78f",
	"./_United Nations.png": "8993",
	"./_england.png": "e8b4",
	"./_scotland.png": "e07e",
	"./_wales.png": "805f",
	"./ad.png": "b939",
	"./ae.png": "74f9",
	"./af.png": "0edd",
	"./ag.png": "23db",
	"./ai.png": "17a6",
	"./al.png": "7b0a",
	"./am.png": "33c5",
	"./an.png": "0f60",
	"./ao.png": "9031",
	"./aq.png": "b4d3",
	"./ar.png": "87f3",
	"./as.png": "3b5b",
	"./at.png": "4a01",
	"./au.png": "7a37",
	"./aw.png": "d715",
	"./az.png": "21a3",
	"./ba.png": "7ca5",
	"./bb.png": "5ea9",
	"./bd.png": "b24b",
	"./be.png": "b124",
	"./bf.png": "4901",
	"./bg.png": "233a",
	"./bh.png": "40ba",
	"./bi.png": "18b4",
	"./bj.png": "6b99",
	"./bm.png": "1fc2",
	"./bn.png": "1865",
	"./bo.png": "3999",
	"./br.png": "04ec",
	"./bs.png": "d77d",
	"./bt.png": "9a1a",
	"./bw.png": "6926",
	"./by.png": "1f2d",
	"./bz.png": "bda7",
	"./ca.png": "40ae",
	"./cd.png": "3955",
	"./cf.png": "81d1",
	"./cg.png": "7619",
	"./ch.png": "6b84",
	"./ci.png": "00b0",
	"./ck.png": "f56e",
	"./cl.png": "502a",
	"./cm.png": "4e1f",
	"./cn.png": "6368",
	"./co.png": "1e8d",
	"./cr.png": "e548",
	"./cu.png": "b256",
	"./cv.png": "3be8",
	"./cy.png": "e479",
	"./cz.png": "7868",
	"./de.png": "e4d8",
	"./dj.png": "430d",
	"./dk.png": "812b",
	"./dm.png": "7ca4",
	"./do.png": "8cc5",
	"./dz.png": "1ee5",
	"./ec.png": "0776",
	"./ee.png": "9075",
	"./eg.png": "18c0",
	"./eh.png": "d2ce",
	"./er.png": "4320",
	"./es.png": "e5f7",
	"./et.png": "f9ba",
	"./fi.png": "f66a",
	"./fj.png": "7a4a",
	"./fm.png": "4f90",
	"./fo.png": "9aac",
	"./fr.png": "78d1",
	"./ga.png": "cc84",
	"./gb.png": "f9f0",
	"./gd.png": "1666",
	"./ge.png": "bd8c",
	"./gg.png": "0b4b",
	"./gh.png": "53e9",
	"./gi.png": "324c",
	"./gl.png": "06ab",
	"./gm.png": "90c1",
	"./gn.png": "68ed",
	"./gp.png": "c2e1",
	"./gq.png": "ae05",
	"./gr.png": "e9e5",
	"./gt.png": "e69a",
	"./gu.png": "93f0",
	"./gw.png": "ffef",
	"./gy.png": "a76f",
	"./hk.png": "aa47",
	"./hn.png": "266d",
	"./hr.png": "dd66",
	"./ht.png": "2edb",
	"./hu.png": "c7df",
	"./id.png": "aae0",
	"./ie.png": "a903",
	"./il.png": "1d53",
	"./im.png": "4c3c",
	"./in.png": "3969",
	"./iq.png": "c9e1",
	"./ir.png": "252c",
	"./is.png": "c96b",
	"./it.png": "5e48",
	"./je.png": "7f41",
	"./jm.png": "9c3d",
	"./jo.png": "4448",
	"./jp.png": "5255",
	"./ke.png": "4f7e",
	"./kg.png": "286f",
	"./kh.png": "d0d6",
	"./ki.png": "c083",
	"./km.png": "9aee",
	"./kn.png": "9244",
	"./kp.png": "8ace",
	"./kr.png": "a88a",
	"./kw.png": "ef96",
	"./ky.png": "5e30",
	"./kz.png": "2f79",
	"./la.png": "98c4",
	"./lb.png": "ebca",
	"./lc.png": "c64d",
	"./li.png": "a3b0",
	"./lk.png": "8c0a",
	"./lr.png": "2c74",
	"./ls.png": "067e",
	"./lt.png": "9e09",
	"./lu.png": "6dc7",
	"./lv.png": "ca91",
	"./ly.png": "bd1f",
	"./ma.png": "8a38",
	"./mc.png": "70e2",
	"./md.png": "aca5",
	"./me.png": "7f87",
	"./mg.png": "2efc",
	"./mh.png": "11a0",
	"./mk.png": "dc64",
	"./ml.png": "3993",
	"./mm.png": "1be46",
	"./mn.png": "326c",
	"./mo.png": "86ba",
	"./mq.png": "8c5e",
	"./mr.png": "cdb1",
	"./ms.png": "91e5",
	"./mt.png": "52ce",
	"./mu.png": "2c82",
	"./mv.png": "31c2",
	"./mw.png": "4a33",
	"./mx.png": "2f3a",
	"./my.png": "7a7d",
	"./mz.png": "a691",
	"./na.png": "d408",
	"./nc.png": "975c",
	"./ne.png": "999e",
	"./ng.png": "2203",
	"./ni.png": "9085",
	"./nl.png": "6dc78",
	"./no.png": "0d97",
	"./np.png": "32ce",
	"./nr.png": "c968",
	"./nz.png": "8f89",
	"./om.png": "b5bf",
	"./pa.png": "cd14",
	"./pe.png": "61a0",
	"./pf.png": "7dde",
	"./pg.png": "eb51",
	"./ph.png": "ad47",
	"./pk.png": "18ac",
	"./pl.png": "ec6a",
	"./pr.png": "42e4",
	"./ps.png": "3a5b",
	"./pt.png": "3c1d",
	"./pw.png": "5277",
	"./py.png": "f043",
	"./qa.png": "7742",
	"./re.png": "ec8e",
	"./ro.png": "316b",
	"./rs.png": "150f",
	"./ru.png": "2d5d",
	"./rw.png": "e8a8",
	"./sa.png": "a50b",
	"./sb.png": "cdf6",
	"./sc.png": "5fff",
	"./sd.png": "c35a",
	"./se.png": "19d1",
	"./sg.png": "747c",
	"./si.png": "06b0",
	"./sk.png": "e7b0",
	"./sl.png": "4033",
	"./sm.png": "3419",
	"./sn.png": "f658",
	"./so.png": "ee5e",
	"./sr.png": "8599",
	"./st.png": "6c27",
	"./sv.png": "8d8a",
	"./sy.png": "afda",
	"./sz.png": "3b63",
	"./tc.png": "4726",
	"./td.png": "d0ab",
	"./tg.png": "59cf",
	"./th.png": "bcf6",
	"./tj.png": "ff36",
	"./tl.png": "c245",
	"./tm.png": "fb95",
	"./tn.png": "fe90",
	"./to.png": "b09b",
	"./tr.png": "42d7",
	"./tt.png": "bdb2",
	"./tv.png": "aa56",
	"./tw.png": "5f05",
	"./tz.png": "fd48",
	"./ua.png": "0f41",
	"./ug.png": "fb67",
	"./us.png": "af86",
	"./uy.png": "02a1",
	"./uz.png": "9a74",
	"./va.png": "2ebe",
	"./vc.png": "0249",
	"./ve.png": "603a",
	"./vg.png": "41b34",
	"./vi.png": "21a2",
	"./vn.png": "cf0c",
	"./vu.png": "cc46",
	"./ws.png": "c347",
	"./ye.png": "2ae5",
	"./za.png": "1ade",
	"./zm.png": "e2c8",
	"./zw.png": "217b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef43";